var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _path6, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvidxchangeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1021_74138)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1021_74138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34085 0C2.4 0 0 2.4 0 5.34085V18.6592C0 21.6 2.4 24 5.34085 24H18.6592C21.6 24 24 21.6 24 18.6592V5.34085C24 2.4 21.6 0 18.6592 0H5.34085Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1021_74138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.09009 0.710156L23.2902 -4.08984L28.124 23.2904L0.709912 28.1242L-4.09009 0.710156Z",
    fill: "url(#paint0_linear_1021_74138)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1021_74138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 4,
    width: 11,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.11 4.02246L9.6001 11.9999H14.4001L19.9776 4.02246H15.11Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1021_74138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4593 6.01711L17.3747 16.496L6.11841 10.0058L12.2029 -0.506836L23.4593 6.01711Z",
    fill: "url(#paint1_linear_1021_74138)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1021_74138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 12,
    width: 11,
    height: 9
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6001 12L15.11 20.0113H19.9776L14.4001 12H9.6001Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1021_74138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.386 25.014L5.74658 14.9069L16.1917 6.99707L23.8311 17.0703L13.386 25.014Z",
    fill: "url(#paint2_linear_1021_74138)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1021_74138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 11,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02246 4.02246L11.9999 15.5154L14.3999 11.9999L8.92387 4.02246H4.02246Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1021_74138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3999 4.02246H4.02246V15.5154H14.3999V4.02246Z",
    fill: "url(#paint3_linear_1021_74138)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3999 11.9999L11.9999 8.48438L4.02246 20.0111H8.92387L14.3999 11.9999Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1021_74138",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 4,
    height: 4
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 8.48438H8.99146V11.9999H11.9999V8.48438Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1021_74138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99146 11.1886L9.59991 11.9999L11.9999 8.48438L8.99146 11.1886Z",
    fill: "#010101"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1021_74138",
    x1: -0.85813,
    y1: 14.264,
    x2: 24.8644,
    y2: 9.72845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0096DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4307,
    stopColor: "#0072A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8039,
    stopColor: "#005882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004E74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1021_74138",
    x1: 17.8213,
    y1: 2.75999,
    x2: 11.7616,
    y2: 13.2558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5CD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0647163,
    stopColor: "#A5CD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9718,
    stopColor: "#00AF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AF4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1021_74138",
    x1: 16.6841,
    y1: 18.5049,
    x2: 11.6783,
    y2: 11.9018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5CD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0647163,
    stopColor: "#A5CD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9718,
    stopColor: "#00AF4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AF4C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1021_74138",
    x1: 5.66139,
    y1: 9.75988,
    x2: 13.3054,
    y2: 9.75988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0647163,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9718,
    stopColor: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D2D3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1021_74138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvidxchangeLogo);
export default __webpack_public_path__ + "static/media/AvidxchangeLogo.9f45fa31b7f823867a24f01b0e5eb97a.svg";
export { ForwardRef as ReactComponent };